import React, { useEffect, useState } from 'react';
import { configure } from 'mobx';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { FlagsProvider, useFlags } from '@atlaskit/flag';
import { ContextualAnalyticsData, FireScreenAnalytics, SCREEN } from '@atlassian/analytics-bridge';
import { ErrorBoundary } from '@atlassian/proforma-common-core/jira-common';
import { InProductHelpProvider, PfFlagsProvider, UtilsProvider } from '@atlassian/proforma-common-core/jira-common-context';
import { createUtils } from '@atlassian/proforma-common-core/jira-common-utils';
import { AnalyticsProvider } from '@atlassian/proforma-utils/analytics';
import { PackageIntlProvider } from '../../common/utils/intl-provider';
import { AffectedServicesChoicesServiceContainer } from '../../services/affected-services';
import { AttachmentServiceContainer } from '../../services/attachments';
import { CmdbChoicesServiceContainer } from '../../services/cmdb';
import { FieldDataServiceContainer } from '../../services/field-data';
import { FormServiceContainer } from '../../services/form';
import { FormChoicesServiceContainer } from '../../services/form-choices';
import { IssueCreateServiceContainer } from '../../services/issue-create';
import { LabelChoicesServiceContainer } from '../../services/label-choices';
import { LastSelectedFormServiceContainer } from '../../services/last-selected-form';
import { ProjectFormsServiceContainer } from '../../services/project-forms';
import { ProjectsServiceContainer } from '../../services/projects';
import { UserChoicesServiceContainer } from '../../services/user-choices';
import { IssueFormsGeneral } from './main';
const JiraIssueFormsGeneralBaseApp = ({
  settings,
  reporterAccountId
}) => {
  const {
    showFlag
  } = useFlags();
  const {
    createAnalyticsEvent
  } = useAnalyticsEvents();
  const [moduleContext, setModuleContext] = useState();
  useEffect(() => {
    const utils = createUtils(settings, 'IssueForms', showFlag, createAnalyticsEvent, settings.context.intlLocale);
    setModuleContext({
      apis: {
        apiUtil: utils.apiUtil
      },
      utils: {
        errorUtils: utils.errorUtils
      }
    });
  }, [createAnalyticsEvent, settings, settings.context.intlLocale, showFlag]);
  if (!moduleContext) {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
  return /*#__PURE__*/React.createElement(ErrorBoundary, {
    errorUtils: moduleContext.utils.errorUtils
  }, /*#__PURE__*/React.createElement(PfFlagsProvider, {
    flags: settings.flags
  }, /*#__PURE__*/React.createElement(UtilsProvider, {
    utils: moduleContext.utils
  }, /*#__PURE__*/React.createElement(FieldDataServiceContainer, {
    apiUtil: moduleContext.apis.apiUtil
  }, /*#__PURE__*/React.createElement(FormChoicesServiceContainer, {
    apiUtil: moduleContext.apis.apiUtil
  }, /*#__PURE__*/React.createElement(FormServiceContainer, {
    apiUtil: moduleContext.apis.apiUtil
  }, /*#__PURE__*/React.createElement(IssueCreateServiceContainer, {
    apiUtil: moduleContext.apis.apiUtil
  }, /*#__PURE__*/React.createElement(LastSelectedFormServiceContainer, {
    errorUtils: moduleContext.utils.errorUtils
  }, /*#__PURE__*/React.createElement(ProjectFormsServiceContainer, {
    apiUtil: moduleContext.apis.apiUtil
  }, /*#__PURE__*/React.createElement(ProjectsServiceContainer, {
    apiUtil: moduleContext.apis.apiUtil
  }, /*#__PURE__*/React.createElement(UserChoicesServiceContainer, {
    apiUtil: moduleContext.apis.apiUtil
  }, /*#__PURE__*/React.createElement(LabelChoicesServiceContainer, {
    apiUtil: moduleContext.apis.apiUtil
  }, /*#__PURE__*/React.createElement(AffectedServicesChoicesServiceContainer, {
    apiUtil: moduleContext.apis.apiUtil
  }, /*#__PURE__*/React.createElement(CmdbChoicesServiceContainer, {
    apiUtil: moduleContext.apis.apiUtil,
    reporterAccountId: reporterAccountId
  }, /*#__PURE__*/React.createElement(AttachmentServiceContainer, {
    apiUtil: moduleContext.apis.apiUtil
  }, /*#__PURE__*/React.createElement(InProductHelpProvider, {
    inProductHelpData: settings.context.inProductHelpData
  }, /*#__PURE__*/React.createElement(IssueFormsGeneral, {
    reporterAccountId: reporterAccountId
  })))))))))))))), /*#__PURE__*/React.createElement(FireScreenAnalytics, null))));
};

/* eslint-disable react/destructuring-assignment */
/**
 * When using this component, ensure:
 *  * it is wrapped by an `AnalyticsListener`, if you want to listen to analytics events
 *  * the `settings` property is static and does not change unless necessary (e.g. wrap it in `useState`)
 */
export const JiraIssueFormsGeneralApp = props => /*#__PURE__*/React.createElement(AnalyticsProvider, props.settings.analytics, /*#__PURE__*/React.createElement(ContextualAnalyticsData, {
  sourceName: "proformaJiraIssueForms",
  sourceType: SCREEN
}, /*#__PURE__*/React.createElement(PackageIntlProvider, {
  locale: props.settings.context.intlLocale
}, /*#__PURE__*/React.createElement(FlagsProvider, null, /*#__PURE__*/React.createElement(JiraIssueFormsGeneralBaseApp, props)))));
/* eslint-enable react/destructuring-assignment */

// Configure MobX to isolate itself from other copies of MobX, such as the MobX loaded by proforma-ui or a third-party Jira app.
configure({
  isolateGlobalState: true
});